export default function AboutFounders() {
  const founders = [
    {
      name: 'Yana',
      role: 'Co-Founder & CEO',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/864749d7f3f4fd54b87e9d6518cbd3c8.jpeg',
      bio: 'With over a decade of experience in healthcare management, Yana brings strategic vision and operational excellence to KaliKare. Her passion for improving lives through quality care drives our commitment to service excellence.'
    },
    {
      name: 'Yasmeen',
      role: 'Co-Founder & Director of Care',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/a2ac5467db4c4ebdbf57ba8cc233d1ac.jpeg',
      bio: 'Yasmeen\'s clinical expertise and dedication to personalized care ensure that every KaliKare client receives the highest standard of service. Her hands-on approach and commitment to caregiver training set us apart.'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Meet Our Founders
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            The visionary leaders behind KaliKare's commitment to excellence
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {founders.map((founder, index) => (
            <div 
              key={index}
              className="bg-gray-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img 
                  src={founder.image}
                  alt={founder.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {founder.name}
                </h3>
                <p className="text-[#5C4F8A] font-semibold mb-4">
                  {founder.role}
                </p>
                <p className="text-gray-600 leading-relaxed">
                  {founder.bio}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
